/**
 * Catálogo de eventos first-party do CalculaMEI.
 * Usado no admin para agrupar telemetria de negócio.
 */

export const EVENT_CATEGORIES = {
  NAVIGATION: 'navigation',
  AUTH: 'auth',
  CALCULATOR: 'calculator',
  PANEL: 'panel',
  ORCAMENTO: 'orcamento',
  BILLING: 'billing',
  EMAIL: 'email',
} as const

export const PRODUCT_EVENTS = {
  PAGE_VIEW: 'page_view',
  PAGE_ENGAGEMENT: 'page_engagement',
  SIGNUP: 'signup',
  LOGIN: 'login',
  ONBOARDING_COMPLETE: 'onboarding_complete',
  CALCULATOR_OPEN: 'calculator_open',
  CALCULATOR_COMPLETE: 'calculator_complete',
  CALCULATOR_SAVE: 'calculator_save',
  CALCULATOR_EXPORT_PDF: 'calculator_export_pdf',
  FATURAMENTO_REGISTER: 'faturamento_register',
  ENTRADA_LANCADA: 'entrada_lancada',
  SAIDA_LANCADA: 'saida_lancada',
  ORCAMENTO_VIEW: 'orcamento_view',
  ORCAMENTO_EDIT: 'orcamento_edit',
  PREMIUM_CTA_CLICK: 'premium_cta_click',
  PREMIUM_EXPORT_BLOCKED: 'premium_export_blocked',
  SUBSCRIPTION_STARTED: 'subscription_started',
  EMAIL_CAMPAIGN_SENT: 'email_campaign_sent',
  LIFECYCLE_NUDGE_FATURAMENTO: 'lifecycle_nudge_faturamento',
  LIFECYCLE_NUDGE_ORCAMENTO: 'lifecycle_nudge_orcamento',
  EMAIL_OPENED: 'email_opened',
  EMAIL_CLICKED: 'email_clicked',
  EMAIL_BOUNCED: 'email_bounced',
  EMAIL_COMPLAINED: 'email_complained',
} as const

export type ProductEventName = (typeof PRODUCT_EVENTS)[keyof typeof PRODUCT_EVENTS]

/** Rotas relevantes para relatório de acesso. */
export function normalizeTelemetryPath(path: string): string {
  if (!path || path === '/') return '/'
  const clean = path.split('?')[0].split('#')[0]
  // Agrupa calculadoras
  if (clean.startsWith('/calculadoras/')) {
    const parts = clean.split('/').filter(Boolean)
    if (parts.length >= 2) return `/calculadoras/${parts[1]}`
    return '/calculadoras'
  }
  if (clean.startsWith('/dashboard')) {
    const parts = clean.split('/').filter(Boolean)
    if (parts.length >= 2) return `/dashboard/${parts[1]}`
    return '/dashboard'
  }
  return clean
}
